module.exports = __webpack_public_path__ + "static/media/cat-visionlink.d43af15d.jpg";